/* LOSMIOS Mundial — countdown(s) to a fixed kickoff date. No deps. Real urgency only. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    document.querySelectorAll('[data-lm-countdown]').forEach(function (el) {
      var target = new Date(el.dataset.lmCountdown).getTime();
      if (isNaN(target)) return;
      var ms = target - Date.now();
      if (ms < 0) ms = 0;
      var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
      var map = { d: d, h: h, m: m, s: s };
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = k === 'd' ? d : pad(map[k]);
      });
      // mirror days into any element with data-lm-days (offset optional)
      document.querySelectorAll('[data-lm-days]').forEach(function (dd) {
        var off = parseInt(dd.dataset.lmDaysOffset || '0', 10) || 0;
        dd.textContent = d + off;
      });
    });
  }
  function boot() { tick(); setInterval(tick, 1000); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
